




































































































































import gql from '@/gqlService.coffee'
import mutations from '@/gql/mutations.coffee'
import queries from '@/gql/queries.coffee'
import settings from '@/settings.coffee'

notifTypes = {
    "Nouveau commentaire": "message",
    "Validation de la réponse": "modification",
    "Text de réponse": "modification",
    "Signalement demandé": "modification",
    "Réponse demandée": "modification",
    "L'établissement prend": "modification",
    "L'établissement ne veux pas": "modification"
}

export default {
    name: 'Notification'
    data: ()->
        opened: false
        notifications: new gql.DataHolder({
            model: "notification_set",
            fields: "uid title message done object_id image created_on",
            autoload: true,
            filters: {consultant: this.$store.state.profile.data.uid}
        })
        avatar: this.$store.state.profile.data.avatar
        backend_root: settings.backendUrl
        sortDirection: 'desc'
        filters:
            message: true
            modification: true
    computed:
        unread: ()->
            this.notifications.results.filter (a)->
                !a.done
        
        filteredAndSortedNotifications: ()->
            filtered = @notifications.results.filter (item)=>
                notiftype = @getNotificationType(item.title)
                return (@filters.message && notiftype == 'message') || 
                       (@filters.modification && notiftype == 'modification')

            filtered.sort (a, b)=>
                dateA = new Date(a.created_on)
                dateB = new Date(b.created_on)
                if @sortDirection == 'asc'
                    return dateA - dateB
                else
                    return dateB - dateA
            return filtered
    watch:
        'filters.message': (newVal)->
            if !newVal && !@filters.modification
                @filters.modification = true
                
        'filters.modification': (newVal)->
            if !newVal && !@filters.message
                @filters.message = true
    methods:
        toggleSortDirection: ()->
            @sortDirection = if @sortDirection == 'asc' then 'desc' else 'asc'
        getNotificationType: (title)->
            for key, value of notifTypes
                if title.startsWith(key)
                    return value
            return 'message'
        getNotifClass: (title)->
            notiftype = @getNotificationType(title)
            if notiftype == 'modification'
                return 'custom-border-info'
            return 'custom-border-warning'
        toggle_read: (notif)->
            console.log("notif", notif)
            mutations.run("notification_toggle_done", [notif.uid]).then ()->
                console.log("READ")
        delete_read: ()->
            mutations.run("notification_delete_read")
        delete_notif: (item)->
            self = this
            mutations.run("notification_delete", [item.uid]).then ()->
                self.notifications.query()
        clicked: (item)->
            self = this
            # self.opened = false
            modalEl = document.getElementById('notif-modal');
            modal = bootstrap.Modal.getInstance(modalEl);
            modal.hide();
            console.log("clicked", item)
            mutations.run("notification_mark_done", [item.uid]).then ()->
                self.$router.push({
                    name: "flow_detail",
                    params: {'uid': item.object_id}
                })
        closeListener: (e)->
            vm = @
            if not vm.$el.contains(e.target)
                vm.opened = false
            return
    mounted: ()->
        document.addEventListener('click', this.closeListener, true)
        return
    beforeDestroy: ()->
        ret = document.removeEventListener('click', this.closeListener, true)

  }
